/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-11 14:05:30
 *
 *******************************************************/
// @flow
//
import React, { Component } from 'react';
import { Layout, Heading, Button, Card, TextStyle, Link } from '@shopify/polaris';
import { CSSTransition } from 'react-transition-group';
import { CaretDownMinor, CaretUpMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type State = {
  active: boolean
};

class PlansQA extends Component<WithI18nProps, State> {
  state = {
    active: 0
  };

  renderQuestionsCol = (questions, startIndex) => {
    const { active } = this.state;
    return questions.map((item, index) => {
      const itemIndex = index + startIndex;

      return (
        <Card key={index}>
          <Card.Header
            title={
              <div className="BC_Card-Header">
                <Heading>{item.question}</Heading>
              </div>
            }>
            <div className="BC-Block-Dismiss--Right-Menu">
              <Button
                icon={active === itemIndex ? CaretDownMinor : CaretUpMinor}
                plain
                onClick={e => this.toggleContent(active === itemIndex ? -1 : itemIndex)}
              />
            </div>
          </Card.Header>
          <CSSTransition
            in={active === index + startIndex}
            timeout={500}
            classNames="item-transition transition"
            unmountOnExit>
            <Card.Section>
              <div className="answer">{item.answer}</div>
            </Card.Section>
          </CSSTransition>
        </Card>
      );
    });
  };

  render() {
    const { i18n } = this.props;
    const questionsLeft = [
      {
        question: i18n.translate('AdminHTML.Subscription.PlansQA.question01'),
        answer: (
          <div>
            <p>
              {i18n.translate('AdminHTML.Subscription.PlansQA.question01_Answer_Text01', {
                t1: (
                  <TextStyle variation="strong">
                    {i18n.translate('AdminHTML.Subscription.PlansQA.question01_Answer_Text01_t1')}
                  </TextStyle>
                )
              })}
            </p>
            <p>{i18n.translate('AdminHTML.Subscription.PlansQA.question01_Answer_Text02')}</p>
            <p>
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.Common.Title.note')}
              </TextStyle>
              {i18n.translate('AdminHTML.Subscription.PlansQA.question01_Answer_Text03')}
            </p>
          </div>
        )
      },
      {
        question: i18n.translate('AdminHTML.Subscription.PlansQA.question02'),
        answer: (
          <div>
            <p>{i18n.translate('AdminHTML.Subscription.PlansQA.question02_Answer_Text01')}</p>
            <p>
              {i18n.translate('AdminHTML.Subscription.PlansQA.question02_Answer_Text02', {
                t1: (
                  <Link
                    url="https://help.shopify.com/en/manual/your-account/manage-account"
                    external>
                    {i18n.translate('AdminHTML.Subscription.PlansQA.question02_Answer_Text02_t1')}
                  </Link>
                )
              })}
            </p>
          </div>
        )
      },
      {
        question: i18n.translate('AdminHTML.Subscription.PlansQA.question03'),
        answer: (
          <div>
            <p>{i18n.translate('AdminHTML.Subscription.PlansQA.question03_Answer_Text01')}</p>
            <p>
              {i18n.translate('AdminHTML.Subscription.PlansQA.question03_Answer_Text02', {
                t1: (
                  <strong style={{ backgroundColor: 'initial' }}>
                    {i18n.translate('AdminHTML.Subscription.PlansQA.question03_Answer_Text02_t1')}
                  </strong>
                )
              })}
            </p>
            <p>
              <img
                style={{ width: '100%' }}
                src="//d33v4339jhl8k0.cloudfront.net/docs/assets/590652f62c7d3a057f88b05d/images/5efae4da2c7d3a10cba9c0b3/file-cNg8lkH1SL.png"
                alt=""
              />
              {i18n.translate('AdminHTML.Subscription.PlansQA.question03_Answer_Text03', {
                t1: (
                  <strong style={{ backgroundColor: 'initial' }}>
                    {i18n.translate('AdminHTML.Subscription.PlansQA.question03_Answer_Text03_t1')}
                  </strong>
                )
              })}
            </p>
            <p>
              <img
                style={{ width: '100%' }}
                src="//d33v4339jhl8k0.cloudfront.net/docs/assets/590652f62c7d3a057f88b05d/images/5efae5a62c7d3a10cba9c0bf/file-0hVhpmFWq6.gif"
                alt=""
              />
            </p>
            <p>{i18n.translate('AdminHTML.Subscription.PlansQA.question03_Answer_Text04')}</p>
            <p>
              https://<strong style={{ backgroundColor: 'initial' }}>yourstore</strong>
              .myshopify.com/admin/apps/product-filter-search/plan&nbsp;
            </p>
            <p>
              {i18n.translate('AdminHTML.Subscription.PlansQA.question03_Answer_Text05', {
                nt_yourstore: <strong>yourstore</strong>
              })}
            </p>
            <p>
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.Common.Title.note')}
              </TextStyle>
              {i18n.translate('AdminHTML.Subscription.PlansQA.question03_Answer_Text06')}
            </p>
          </div>
        )
      },
      {
        question: i18n.translate('AdminHTML.Subscription.PlansQA.question04'),
        answer: (
          <div>
            <p>{i18n.translate('AdminHTML.Subscription.PlansQA.question04_Answer_Text01')}</p>
            <p>{i18n.translate('AdminHTML.Subscription.PlansQA.question04_Answer_Text02')}</p>
            <p>{i18n.translate('AdminHTML.Subscription.PlansQA.question04_Answer_Text03')}</p>
            <p>
              <em>
                https://<strong>yourstore</strong>.myshopify.com/admin/products/count.json&nbsp;
              </em>
            </p>
            <p>
              {i18n.translate('AdminHTML.Subscription.PlansQA.question04_Answer_Text04', {
                nt_yourstore: <strong>yourstore</strong>
              })}
            </p>
          </div>
        )
      },
      {
        question: i18n.translate('AdminHTML.Subscription.PlansQA.question05'),
        answer: (
          <div>
            <p>
              {i18n.translate('AdminHTML.Subscription.PlansQA.question05_Answer_Text01', {
                t1: (
                  <Link
                    url="https://help.boostcommerce.net/article/423-what-exactly-counts-as-a-product"
                    external>
                    {i18n.translate('AdminHTML.Subscription.PlansQA.question05_Answer_Text01_t1')}
                  </Link>
                ),
                t2: (
                  <strong>
                    {i18n.translate('AdminHTML.Subscription.PlansQA.question05_Answer_Text01_t2')}
                  </strong>
                )
              })}
            </p>
            <p>{i18n.translate('AdminHTML.Subscription.PlansQA.question05_Answer_Text02')} </p>
            <p>
              <img
                style={{ width: '100%' }}
                src="//d33v4339jhl8k0.cloudfront.net/docs/assets/590652f62c7d3a057f88b05d/images/5f45d8232c7d3a352e9161c2/file-sKojzdVBcr.png"
                alt=""
              />
            </p>
            <p>
              {i18n.translate('AdminHTML.Subscription.PlansQA.question05_Answer_Text03', {
                t1: (
                  <strong>
                    {i18n.translate('AdminHTML.Subscription.PlansQA.question05_Answer_Text03_t1')}
                  </strong>
                )
              })}
            </p>
            <p>{i18n.translate('AdminHTML.Subscription.PlansQA.question05_Answer_Text04')}</p>
            <p>
              {i18n.translate('AdminHTML.Subscription.PlansQA.question05_Answer_Text05', {
                nt_break_line: <br />,
                t1: (
                  <Link
                    url="https://help.shopify.com/en/manual/your-account/manage-account"
                    external>
                    {i18n.translate('AdminHTML.Subscription.PlansQA.question05_Answer_Text05_t1')}
                  </Link>
                )
              })}
            </p>
          </div>
        )
      }
    ];

    const questionsRight = [
      {
        question: i18n.translate('AdminHTML.Subscription.PlansQA.question06'),
        answer: (
          <div>
            <p>{i18n.translate('AdminHTML.Subscription.PlansQA.question06_Answer_Text01')}</p>
            <p>{i18n.translate('AdminHTML.Subscription.PlansQA.question06_Answer_Text02')}</p>
            <p>
              {i18n.translate('AdminHTML.Subscription.PlansQA.question06_Answer_Text03', {
                t1: (
                  <Link
                    url="https://help.boostcommerce.net/article/349-guide-to-uninstallation"
                    external>
                    {i18n.translate('AdminHTML.Subscription.PlansQA.question06_Answer_Text03_t1')}
                  </Link>
                )
              })}
            </p>
          </div>
        )
      },
      {
        question: i18n.translate('AdminHTML.Subscription.PlansQA.question07'),
        answer: (
          <div>
            <p>{i18n.translate('AdminHTML.Subscription.PlansQA.question07_Answer_Text01')}</p>
            <p>
              {i18n.translate('AdminHTML.Subscription.PlansQA.question07_Answer_Text02', {
                nt_yourstore: <strong>yourstore</strong>
              })}
            </p>
            <p>{i18n.translate('AdminHTML.Subscription.PlansQA.question07_Answer_Text03')}</p>
          </div>
        )
      },
      {
        question: i18n.translate('AdminHTML.Subscription.PlansQA.question08'),
        answer: (
          <div>
            <p>{i18n.translate('AdminHTML.Subscription.PlansQA.question08_Answer_Text01')}</p>
          </div>
        )
      },
      {
        question: i18n.translate('AdminHTML.Subscription.PlansQA.question09'),
        answer: (
          <div>
            <p>{i18n.translate('AdminHTML.Subscription.PlansQA.question09_Answer_Text01')}</p>
            <p>
              {i18n.translate('AdminHTML.Subscription.PlansQA.question09_Answer_Text02', {
                t1: (
                  <Link url="https://help.boostcommerce.net/article/424-how-to-subscribe" external>
                    {i18n.translate('AdminHTML.Subscription.PlansQA.question09_Answer_Text02_t1')}
                  </Link>
                )
              })}
            </p>
          </div>
        )
      }
    ];
    return (
      <div className="questions">
        <div className="align-center card-title-uppercase title">
          <Heading>{i18n.translate('AdminHTML.Subscription.PlansQA.title')}</Heading>
        </div>
        <Layout>
          <Layout.Section oneHalf>{this.renderQuestionsCol(questionsLeft, 0)}</Layout.Section>
          <Layout.Section oneHalf>
            {this.renderQuestionsCol(questionsRight, questionsLeft.length)}
          </Layout.Section>
        </Layout>
      </div>
    );
  }

  toggleContent = index => {
    this.setState({ active: index });
  };
}

export default withI18n()(PlansQA);
